import PropTypes from 'prop-types'
import React from 'react'

import ButtonScrollDown from 'components/ButtonScrollDown'
import { GOODS_TYPES } from 'constants/sales'
import AddAndGoToCart from 'containers/AddAndGoToCart'
import CostContainerSale from 'containers/CostContainerSale'
import { MenuMainContext } from 'contexts/MenuMain'
import { TextLH, H1Small as H1 } from 'styles/components/typography'

import WgsEffect from './components/WgsEffect'
import {
  FirstBlockWrapperStyled,
  TextWrapper,
  ScrollDownWrapper,
} from './styles'

const WResultsFirst = ({ data, secondBlockRef }) => {
  const { isSalesBanner, salesBannerHeight } = React.useContext(MenuMainContext)
  return (
    <FirstBlockWrapperStyled
      isExtraTopIndent={isSalesBanner}
      indentHeight={salesBannerHeight}
      className="pb-2 pb-md-4"
      beforeElement={
        <div className="position--full">
          <WgsEffect />
        </div>
      }
    >
      <div className="first-content-top-indent row">
        <div className="col-12 offset-md-6 col-md-6 offset-lg-4 col-lg-8">
          <H1 dangerouslySetInnerHTML={{ __html: data.title }} />

          <TextWrapper>
            <TextLH dangerouslySetInnerHTML={{ __html: data.content }} />
          </TextWrapper>

          <div className="pt-3 pt-md-4">
            <div className="d-flex align-items-center">
              <CostContainerSale
                className="mr-15"
                productType={GOODS_TYPES.wgs}
                isMobileCenter={true}
                isWhite={true}
              />
              <AddAndGoToCart
                goods={[
                  {
                    type: GOODS_TYPES.wgs,
                    isSubscription: false,
                  },
                ]}
                buttonProps={{
                  bgClassName: 'bg--green',
                  withTopMarginOnMobile: true,
                }}
                buttonTitleKey={'order_test'}
                forceMultipleAdd={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <ScrollDownWrapper>
            <ButtonScrollDown
              isLightColor={true}
              title={data.go_to_site}
              refToScroll={secondBlockRef}
            />
          </ScrollDownWrapper>
        </div>
      </div>
    </FirstBlockWrapperStyled>
  )
}

WResultsFirst.propTypes = {
  data: PropTypes.object.isRequired,
  secondBlockRef: PropTypes.object.isRequired,
}

export default WResultsFirst
